// removed by extract-text-webpack-plugin
module.exports = {"root":"_362PB_36","disabled":"_3H9Uz_3H","relative":"_8IfYS_8I"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Dropdown/Dropdown.css
// module id = 746
// module chunks = 0